
export default function Logo() {
  return (
    <img src={`${process.env.PUBLIC_URL}/images/logo.svg`} width="97" height={44.3}></img>
  )
}
